import React from 'react';
import PropTypes from 'prop-types';
import DsBtn from '../atoms/btn';
import DsImage from '../atoms/image/Image';

const TravelTips = ({ className, travelTips }, context) => {
  if (!travelTips) {
    return null;
  }
  return (
    <div className={`${className || ''} `}>
      <header className="mx-4 text-xs mt-4 text-primary-500">
      {context.t('PLAN YOUR TRIP')}
      </header>
    <ul className="flex flex-wrap  mx-2">
      {travelTips.map((tip) => (
        <li key={tip.id} className="m-2" title={tip.title}>
          <DsBtn href={tip.url}>
          <figure className="bg-primary p-3 w-16 h-16 rounded-full">
             <DsImage img={tip.logo.url} alt={tip.logo.name} className="w-full"/>
             </figure>
        </DsBtn>
        {tip.href}
          </li>
      ))}
    </ul>
    </div>
  );
};
TravelTips.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default TravelTips;
